import React, { FC } from 'react'
import 'App.css'
import { useEFSData } from '@dectech/react-library'
import { ExperimentApp } from 'AppComponents/ExperimentApp'
import { StandaloneBasketApp } from 'AppComponents/StandaloneBasketApp'
import { StandaloneProductRangeApp } from 'AppComponents/StandaloneProductRangeApp'

const App: FC = () => {
  const { showStandaloneBasket, showProductRangeOnly } = useEFSData<{
    showStandaloneBasket?: boolean
    showProductRangeOnly?: boolean
  }>()
  if (showStandaloneBasket) {
    return <StandaloneBasketApp />
  }

  if (showProductRangeOnly) {
    return <StandaloneProductRangeApp />
  }

  return <ExperimentApp />
}

export default App
